import {Extent, getArea} from 'ol/extent.js';

export * from './compare.ts';
export * from './labs.ts';
export * from './modals.ts';
export * from './mosaics.ts';
export * from './orders.ts';
export * from './processes.ts';
export * from './sort.ts';

export const ITEM_COUNT_LIMIT = 100;
export const DEFAULT_ZOOM = 2;
export const DRAG_TYPE = 'Text';
export const MAX_FULL_ACCESS_ZOOM = 15; // highest resolution basemap tiles available
export const MAX_HIGH_RES_LIMITED_ACCESS_ZOOM = 13; // SkySat tiles outside constraint geometry stop here
export const MAX_ZOOM = 20; // map stops here
export const MAX_LIMITED_ACCESS_ZOOM = 10; // SS tiles outside constraint geometry stop here

/** Downsampling Limits */
export const DOWNSAMPLE_ZOOM = 11;
export const DOWNSAMPLE_THRESHOLD = 0.25;

export const MAX_TILESET_ITEMS = 30;
export const MAX_VISIBLE_RESULTS = 10;

export const MAX_GEOMETRY_AREA = 50000; // Maximum area in square km

export const SERIES_DELIM = '.';

export const DEFAULT_PROCESS = 'rgb';

export const GEO_PROJECTION = 'EPSG:4326';
export const WEB_PROJECTION = 'EPSG:3857';
export const UTM_PROJECTION = 'UTM';

export const PROJECTION_LABELS = {
  3857: 'Web Mercator (EPSG: 3857)',
  4326: 'World Geodetic System (EPSG: 4326)',
  UTM: 'UTM (auto zone)',
} as const;

// Trials
export const EVALUATION_PROGRAM_ID = 29;

export const WORLD_EXTENT = [-180, -90, 180, 90] as Extent;
export const WORLD_EXTENT_AREA = getArea(WORLD_EXTENT);

export const MAX_VERTEX_COUNT = 1500;
